import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

const ModalWindowTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle
            disableTypography
            sx={{ margin: 0 }}
            {...other}
        >
            <Typography variant="h6">{children}</Typography>
            {
                onClose ?
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 1,
                            top: 1,
                            color: 'grey.500',
                        }}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton> :
                    null
            }
        </DialogTitle>
    );
};

ModalWindowTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default ModalWindowTitle;
